<template>
  <a-config-provider :locale="zhCN" :theme="{
    token: {
      colorPrimary: '#448DF4',
      borderRadius: 0,
      colorBgContainer: '#141623',
      colorBgElevated: '#141623'
    }, algorithm: theme.darkAlgorithm,
  }">
    <div v-if="loading" class="loading-container">
      <a-spin tip="正在加载中..." size="large" />
    </div>
    <router-view v-else />
  </a-config-provider>
</template>

<script setup>
import { theme } from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { onMounted,ref } from 'vue';
const loading = ref(true);
onMounted(() => {
  document.title = `${process.env.VUE_APP_WEB_NAME}`
  document.getElementById('favicon').href = `${process.env.VUE_APP_ICON}`;
  // 模拟加载数据，比如用户信息 / 配置项 / 权限
  setTimeout(() => {
    loading.value = false;
  }, 1500);
});
</script>
<style>
#app {
  font-family: Arial, Avenir, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #cccccc;
  font-size: 14px;
}

.ant-drawer-body {
  color: #cccccc;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
body {
  background-color: var(--bgBody);
  /* min-width: 1280px; */
}

@media (min-width: 800px) {
  body {
    min-width: 1280px;
  }
}

body,
p {
  margin: 0 !important;
  padding: 0 !important;
}

/* 分页 */
.pagination-bar {
  text-align: right;
  margin-top: 10px;
}

#webpack-dev-server-client-overlay {
  display: none !important;
}

::-webkit-scrollbar {
  width: 5px;
  /* 纵向滚动条*/
  height: 5px;
  /* 横向滚动条 */
  /* background-color: #fff; */
  background-color: #448df427;
}

/*定义滚动条轨道 内阴影*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  /* background-color: #fff; */
  background-color: #448df427;
}

/*定义滑块 内阴影*/
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0);
  background-color: rgba(164, 166, 172, 0.3);
  border-radius: 10px;
}
</style>
